@if (visibility) {
    <div [id]="'container-check-modal-'+environment.data.brand" class="container-check-modal">
        <div id="check-modal-form">
            <span class="close-icon" aria-hidden="true" (click)="close()">&times;</span>
            <div class="row w-100 pl-3 pb-3 text-center">
                <div class="bold-text align-content-center w-100 pb-3 nudge-right blue-color">Basculer vers un autre
                    compte
                </div>
                <div class="col-12">
                    @for (customer of data; track customer) {
                        <div class="row w-100 pointer-cursor" (click)="setSelectedCustomer(customer.customerId)">
                            <div class="col-2">
                                <input type="radio" [id]="'choice'+customer.customerId" class="form-check-input"
                                       name="pro-feet-choice" [value]="customer.customerId"
                                       [checked]="connectedCustomer.id == customer.customerId"/>
                            </div>
                            <div class="col-10">
                                @if (['', null].indexOf(customer.siret) != -1) {
                                    <label class="pointer-cursor" [for]="'choice'+customer.customerId">
                                        [{{ customer.customerId }}] {{ customer.lastName + ' ' + customer.firstName }}
                                    </label>
                                }
                                @if (['', null].indexOf(customer.siret) == -1) {
                                    <label class="pointer-cursor" [for]="'choice'+customer.customerId">
                                        [{{ customer.customerId }}] {{ customer.company }}
                                    </label>
                                }
                            </div>
                        </div>
                    }
                </div>
                <button type="button" class="cta_btn level_2" (click)="getToken()">Valider<span></span></button>
            </div>
        </div>
    </div>
}
